import { Stack } from '@ekhodealer/ekho-common/rev';

import { TablePageLayout } from '@common/components/TablePageLayout';
import UsageHeader from '@features/plan_and_usage/components/UsageHeader';
import UsageTable from '@features/plan_and_usage/components/UsageTable';
import UsageToolbar from '@features/plan_and_usage/components/UsageToolbar';

export default function UsagePage() {
	return (
		<TablePageLayout
			title='Usage'
			aboveTableContent={
				<Stack itemsSpacing='24'>
					<UsageHeader />
					<UsageToolbar />
				</Stack>
			}
			tableContent={<UsageTable />}
		/>
	);
}
